import { getPathUrl } from "../../utils/general";

export const getDashboards = (access_token, theme="Dark") => {
    const accessTokenParam = access_token?.length > 0 ? `var-accesstoken=${access_token}&` : "";
    const createLink = (path, extraParams = '') => getPathUrl(
      `/d/${path}?${extraParams}${accessTokenParam}&kiosk&hideLogo=true`+(theme  !== "Light" ? "" : "&theme=light"), "spacefana");

    // This sets the order the dashboards appear
    return [
        {
          name: "GEO Summary",
          link: createLink('5oK_KFK4z/geo-summary', 'refresh=5m&'),
          description: "Shows ongoing RPO's and recent drifters in GEO.",
          tags: ["GEO", "summary", "overview", "drifters", "RPO"],
          image: "geo-summary",
        },
        {
          name: "Satellite Overview",
          link: createLink('eegfx7b7aeps0c/overview'),
          description: "At a glance trends for a satellite. Shows position, RF, and optical activity.",
          tags: ["satellite", "overview", "analysis"],
          image: "satellite-overview",
        },
        {
          name: "Waterfall",
          link: createLink('KPR_hDkVz/geo-waterfall', 'var-showSun=no&'),
          description: "GEO Waterfall, provides real-time metric observations on objects in GEO.",
          tags: ["optical", "waterfall", "GEO", "photometry"],
          image: "waterfall",
        },
        {
          name: "Light Curves",
          link: createLink('RCHUUtW4z/photometry'),
          description: "Photometric light curves provide indications of spacecraft stability, changes in attitude, or bus configuration changes.",
          tags: ["optical", "photometry", "brightness", "vmag", "stability", "attitude", "bus configuration"],
          image: "light-curves",
        },
        {
          name: "Monet Plot",
          link: createLink('ae9pzazusvkzke/monetplot'),
          description: "Shows longer term photometric trends and variations.",
          tags: ["optical", "monet", "photometry", "stability", "attitude", "bus configuration"],
          image: "monet-plot",
        },
        {
          name: "Elset History",
          link: createLink('PO81TfmVk/elset-history'),
          description: "Shows changes in RSO orbital elements over time using both TLE's and State Vectors.",
          tags: ["elset", "TLE", "orbital elements", "history", "state vector"] ,
          image: "elset-history",
        },
        {
          name: "Conjunctions",
          link: createLink('bK3mC9nP2w/conjunctions'),
          description: "Shows conjunction events between satellites over a selected time range.",
          tags: ["conjunction", "collision", "TCA", "miss distance"],
          image: "conjunctions",
        },
        {
          name: "EMI Spectrum",
          link: createLink("c9f2b443-5325-479c-8f9e-566e07fd4d18/rf-observations"),
          description: "Provides real-time RF electromagnetic interference spectrum observations.",
          tags: ["RF", "spectrum", "EMI", "electromagnetic", "interference", "observations"],
          image: "emi-spectrum",
        },
        {
          name: "TDOA History",
          link: createLink('d653e5fe-c061-4372-8263-b3e99004c302/tdoa-history'),
          description: "Time Difference of Arrival history",
          tags: ["RF", "TDOA", "geolocation"],
          image: "tdoa-history",
        },
        {
          name: "TDOA History Multiplot",
          link: createLink('fec3bdd0-87e1-462a-9324-9b2be4f65bce/tdoa-history-multiplot'),
          description: "Multi-satellite TDOA history comparison.",
          tags: ["RF", "TDOA", "multiplot", "comparison"],
          image: "tdoa-history-multiplot",
        },
        {
          name: "Maneuver History",
          link: createLink('feapme7gzwwlcd/maneuver-history'),
          description: "Experimental: Historical maneuver detection and tracking from various providers.",
          tags: ["maneuver", "history", "detection"],
          image: "maneuver-history",
        },
        {
          name: "Maneuver Recovery",
          link: createLink('AD87a4bc/maneuver-recovery'),
          description: "Performs Lambertian orbit recovery analysis between two RSO States.",
          tags: ["maneuver", "recovery", "orbit"],
          image: "maneuver-recovery",
        },
        {
          name: "DC Table",
          link: createLink('f53650e4/dc-table'),
          description: "Shows the Delta/difference between two RSO States in a table format.",
          tags: ["maneuver", "differential correction", "DC"],
          image: "dc-table",
        },
        {
          name: "Reachable Volume",
          link: createLink('aejmlbbkgbl6oa/threatassesment'),
          description: "Shows all targets an RSO could maneuver to given a dV, time or sun-angle constraint.",
          tags: ["maneuver", "threat", "reachable volume"],
          image: "reachable-volume",
        },
        {
          name: "Residuals",
          link: createLink('FOBAMEzVz/residuals'),
          description: "Shows the residual error between the observed and predicted RSO position.",
          tags: ["maneuver", "residuals", "observation", "optical", "photometry", "TDOA", "RF", "EO", "Radar"],
          image: "residuals",
        },
        {
          name: "COCO / RPO",
          link: createLink('be791bd0-9a37-45d7-b956-029966d4b570/rpo'),
          description: "Co-Orbital, Co-Planar and Rendezvous Proximity Operations check for a given RSO.",
          tags: ["COCO", "RPO", "proximity", "rendezvous"],
          image: "coco-rpo",
        },

        {
          name: "SatVul",
          link: createLink('fdwfc04e39on4f/satellite-threats'),
          description: "Returns all RSO's that threaten a particular ground location or ground-track.",
          tags: ["vulnerability", "threat", "ground"],
          image: "satvul",
        },
        {
          name: "Sensor Pass Schedule",
          link: createLink('eekb6trhi99tsd/sensor-pass-schedule'),
          description: "Returns all sensor passes for a given RSO state.",
          tags: ["sensor", "pass", "schedule", "ground"],
          image: "sensor-pass-schedule",
        },
        {
          name: "2D Ground Track",
          link: createLink('b4409bf7-0440-42d5-aa95-c21ac457029d/ground-track'),
          description: "2D ground track projection of an RSO state.",
          tags: ["ground track", "2D", "map"],
          image: "2d-ground-track",
        },
        {
          name: "Image Viewer",
          link: createLink('cdwujo30o8wsgd/asat-threats'),
          description: "Shows the latest imagery of a particular ground location.",
          tags: ["image", "viewer", "ASAT"],
          image: "image-viewer",
        },
        {
          name: "Generate Launch Nominal",
          link: createLink('4b5928f8-275e-4ef1-97ee-7d1df300aa48/launch-nominal-generator'),
          description: "Generates a launch nominal given the launch date/time, location, Predicted Orbit, NOTAM's or launch azimuth constraints.",
          tags: ["launch", "nominal", "generator", "NOTAM", "launch azimuth"],
          image: "generate-launch-nominal",
        },
        {
          name: "Launch Profiles",
          link: createLink('aacbb349-7831-4ace-9e1b-91212b360232/launch-profiles'),
          description: "List of previous launches and their resulting orbits for given launch vehicles. Search for launches by NOTAM.",
          tags: ["launch", "profile", "folders"],
          image: "launch-profiles",
        },
        {
            name: "GEO Neighborhood",
            link: createLink('ce58nh4hgpypse/longitudeGEO Neighborhood'),
            description: "Table summary of all RSO's in a particular GEO Neighborhood.",
            tags: ["GEO", "neighborhood", "longitude"],
            image: "geo-neighborhood",
        },
        {
            name: "TRIC History",
            link: createLink('ZXiz9jkVk/tric'),
            description: "Time, Radial, In-Track and Cross-Track Characterization of two RSO's using historical State data.",
            tags: ["TRIC", "characterization", "history", "radial", "in-track", "cross-track"],
            image: "tric-history",
        },
        {
          name: "TRIC Single",
          link: createLink('fa1eefd6-9ca5-438e-bd92-ec04db2365b1/tric-manual'),
          description: "Time, Radial, In-Track and Cross-Track Characterization of two RSO's using user defined states for each RSO.",
          tags: ["TRIC", "characterization", "single", "radial", "in-track", "cross-track"],
          image: "tric-single",
        },
        {
          name: "LEO Waterfall",
          link: createLink('aea48nghbugw0b/leo-waterfall'),
          description: "Provides the relative distance, inclination & RAAN offsets between two RSO's in LEO.",
          tags: ["LEO", "waterfall", "relative distance", "inclination", "RAAN"],
          image: "leo-waterfall",
        },
        {
          name: "Threat Monitor",
          link: createLink('fdm1ev7wgn9j4b/constellation-monitor'),
          description: "Returns a threat assessment for a user defined list of RSO's against user defined parameters such as delta distance, inclination, RAAN, etc.",
          tags: ["threat", "monitor", "constellation"],
          image: "threat-monitor",
        },
        {
            name: "Altitude v.s Inclination",
            link: createLink('JcXBmud4z/altitudeinclination'),
            description: "Plots Altitude against Inclination and Inclination against RAAN, for all RSO's to identify any potential constellation trends.",
            tags: ["altitude", "inclination", "scatter"],
            image: "altitude-vs-inclination",
        },
        {
            name: "Provider Status",
            link: createLink('ff16adf2-0eb2-4fb1-a602-380f95b82303/data-status'),
            description: "Shows the status of the data providers for the various dashboards.",
            tags: ["provider", "status", "data"],
            image: "provider-status",
        },
        {
            name: "Sensor Map",
            link: createLink('D8fDCYO4k/sensor-map'),
            description: "Global sensor location map showing all ground-based sensors and their coverage areas.",
            tags: ["sensor", "map", "ground"],
            image: "sensor-map",
        },
        {
            name: "Orbit Determination",
            link: createLink('f3a6255f-40d8-4b9e-8f6a-0c5bfbdc198d/orbit-determination'),
            description: "Performs a wide range of Initial Orbit Determination (IOD) and Orbit Determination (OD) methods to move from raw observations into a complete orbit solution.",
            tags: ["orbit", "OD", "determination", "BLS", "UKF", "least squares", "kalman filter", "state vector", "TLE", "covariance", "IOD", "residuals"],
            image: "orbit-determination",
        },
        {
            name: "Space Weather",
            link: createLink('rC4UUfW4d/space-weather'),
            description: "Proton Energy Levels & X-Ray flux using GOES data, provides real-time solar environment conditions.",
            tags: ["space weather", "environment", "solar"],
            image: "space-weather",
        },
        {
            name: "State Update Catalog",
            link: createLink('c7kStateUpd01/state-update-catalog'),
            description: "Browse the status, schedule and results of Saber's state update engine",
            tags: ["OD", "automation", "schedule", "state update", "catalog"],
            image: "state-update-catalog",
        },
        {
            name: "GEO Crossings",
            link: createLink('eej0rtwhoszr4a/geo-insertion'),
            description: "Determine GEO Crossing points for a given RSO and determine secondary RSO's in the vicinity.",
            tags: ["GEO", "crossing", "insertion", "GTO"],
            image: "geo-crossings",
        },
        {
            name: "TapLab Viewer",
            link: createLink('cejmcw2uhyw3kc/sda-kafka'),
            description: "View visualizations of the SDA Tap Lab KAFKA Bus Topics and their data.",
            tags: ["TapLab", "kafka", "data", "stream"],
            image: "taplab-viewer",
        },
    ];
}

export const DASHBOARDS = getDashboards("").map(({name}) => name);

const dashboardMetaMap = Object.fromEntries(
    getDashboards("").map(({ name, description, tags, image }) => [name, { description: description ?? "", tags: tags ?? [], image: image ?? "" }])
);

export const getDashboardMeta = (name) => dashboardMetaMap[name] ?? { description: "", tags: [], image: "" };

export const VALID_EX_EVENT_DASHES = ["Space Cockpit", ...DASHBOARDS];

export const encodeDashboardName = (name) => {
  return name.toLowerCase()
    .replaceAll(" / ", "-")
    .replaceAll("/", "-")
    .replaceAll(" ", "-")
    .replaceAll(/[^a-zA-Z0-9-]/g, "") // non allowed characters
}

export const getDashboardIndex = (dashboards, name) => {
  const encoded = encodeDashboardName(name);
  return dashboards.findIndex(x => encodeDashboardName(x.name) === encoded);
}

// This will enable the Space Cockpit 3D panel on these dashboards.
export const SpaceCockpitPositions = {
  "GEO Summary": {position: "right", size: 0.33},
  "Maneuver History": {position: "bottom", size: 0.5},
  "COCO / RPO": {position: "right", size: 0.33},
  "Alerts": {position: "right", size: 0.5},
  "LEO Waterfall": {position: "right", size: 0.33},
  "Reachable Volume": {position: "right", size: 0.5},
  "Maneuver Recovery": {position: "right", size: 0.3},
  //"DC Table": {position: "right", size: 0.3},
  "GEO Crossings": {position: "right", size: 0.6},
  "TapLab Viewer": {position: "right", size: 0.33},
  "Sensor Pass Schedule": {position: "right", size: 0.33},
  "Generate Launch Nominal": {position: "right", size: 0.33},
  "Elset History": {position: "right", size: 0},
  "EMI Spectrum": {position: "right", size: 0},
  "TRIC History": {position: "right", size: 0}, // hidden by default
  "TRIC Single": {position: "right", size: 0}, 
  "GEO Neighborhood": {position: "right", size: 0}, 
  "Light Curves": {position: "right", size: 0.3},
  "Orbit Determination": {position: "right", size: 0.33},
  "Conjunctions": {position: "right", size: 0.33},
}